import { CLIENT_CERTIFICATES_TABLE } from './client_certificates';

export const CertificatesReport = {
  en: {
    ...CLIENT_CERTIFICATES_TABLE.en,
    'Certificate Reports': 'Certificate Reports',
    certificates_report_hint:
      'Certificates sold to clients, company-wide. Expand a row to see what is inside and how much of it is left.',
  },
  uk: {
    ...CLIENT_CERTIFICATES_TABLE.uk,
    'Certificate Reports': 'Обіг сертифікатів',
    certificates_report_hint:
      'Сертифікати, продані клієнтам, по всій компанії. Розгорніть рядок, щоб побачити наповнення і залишки.',
  },
};
